<template>
  <div class="col-xs-12 py-3 px-5">
    <loading-overlay :loading="!!unwrapstatus" :text="unwrapstatus" />
    <modal
      v-if="popupModal"
      @modalconfirm="onModalConfirm"
      @modalclose="onModalClose"
      body="Proceed with MetaMask?"
    ></modal>

    <div class="d-sm-none">
      <div class="text-start wrapinput-label" style="font-size: 16px; margin-top: 10px; margin-bottom: 20px; color: #e5c300; font-weight: bold; text-align: center !important;">
        -------- You are currently unwrapping PUT to wPUT!! Please follow the green instructions below! --------<br />
        (Unwrapping in this context means, that you now burn your wPUT and get PUT back from the custodian!)
      </div>

      <input
        id="sessionnetwork"
        class="form-control wrapinput"
        type="text"
        :value="selectedNetworkDescription"
        readonly
      />
      <div class="wrapinput-label-container text-start">
        <label for="sessionnetwork" class="form-label wrapinput-label "
          >SMART CONTRACT PLATFORM</label
        >
      </div>

      <input
        id="sessionamount"
        class="form-control wrapinput"
        :class="{ invalid: !aboveMinAmount }"
        type="number"
        v-model="amount"
        @keypress="onlyForCurrency"
      />
      <div class="wrapinput-label-container text-start">
        <label for="sessionamount" class="form-label wrapinput-label "
          >wPUT AMOUNT to UNWRAP (10,000 wPUT minimum)</label
        >
      </div>

      <input
        id="sessionpeercoinaddress"
        class="form-control wrapinput"
        :class="{ invalid: !validPPCAddress }"
        type="text"
        v-model="destinationPPCAddress"
        @keypress="onlyForAddress"
      />
      <div class="wrapinput-label-container text-start">
        <label for="sessionpeercoinaddress" class="form-label wrapinput-label "
          >!!VALID!! PUTinCoin ADDRESS (starting with "P")</label
        >
      </div>

      <div class="text-start moveup">
        <img
          class="foxy-down"
          alt="MetaMask"
          height="15"
          src="../assets/metamask-fox.svg"
        />
        <input
          id="sessionaccount"
          class="form-control wrapinput accounttext moverightpadding"
          type="text"
          :value="destinationETHAddress"
          readonly
        />
        <div class="wrapinput-label-container text-start">
          <label for="sessionaccount" class="form-label wrapinput-label "
            >CONNECTED ACCOUNT</label
          >
        </div>
      </div>
    </div>

    <!-- sm view or larger: -->

    <div class="d-none d-sm-block px-5">
      <div class="text-start wrapinput-label" style="font-size: 16px; margin-top: 10px; margin-bottom: 20px; color: #e5c300; font-weight: bold; text-align: center !important;">
        -------- You are unwrapping PUT to wPUT!! Please follow the green instructions below! --------<br />
        (Unwrapping means, you now burn your wPUT and get PUT back from the custodian!)
      </div>

      <input
        id="sessionnetwork"
        class="form-control wrapinput"
        type="text"
        :value="selectedNetworkDescription"
        readonly
      />
      <div class="wrapinput-label-container text-start">
        <label for="sessionnetwork" class="form-label wrapinput-label "
          >SMART CONTRACT PLATFORM</label
        >
      </div>

      <input
        id="sessionamount"
        class="form-control wrapinput"
        :class="{ invalid: !aboveMinAmount }"
        type="number"
        v-model="amount"
        @keypress="onlyForCurrency"
      />
      <div class="wrapinput-label-container text-start">
        <label for="sessionamount" class="form-label wrapinput-label "
          >wPUT AMOUNT to UNWRAP (10,000 wPUT minimum)</label
        >
      </div>

      <input
        id="sessionpeercoinaddress"
        class="form-control wrapinput"
        :class="{ invalid: !validPPCAddress }"
        type="text"
        v-model="destinationPPCAddress"
        @keypress="onlyForAddress"
      />
      <div class="wrapinput-label-container text-start">
        <label for="sessionpeercoinaddress" class="form-label wrapinput-label "
          >!!VALID!! PUTinCoin ADDRESS (starting with "P")</label
        >
      </div>

      <div class="text-start moveup">
        <img
          class="foxy-down-lg"
          alt="MetaMask"
          height="15"
          src="../assets/metamask-fox.svg"
        />
        <input
          id="sessionaccount"
          class="form-control wrapinput accounttext-lg moverightpadding"
          type="text"
          :value="destinationETHAddress"
          readonly
        />
        <div class="wrapinput-label-container  text-start">
          <label for="sessionaccount" class="form-label wrapinput-label "
            >CONNECTED ACCOUNT</label
          >
        </div>
      </div>
    </div>

    <!-- all views -->

    <div class="row mb-2" v-if="!callingunwrap">
      <div class="d-sm-block px-5" v-if="!!validForm">
        <input
          id="amounttoget"
          class="form-control wrapinput"
          style="font-size: 20px; font-weight: bold;"
          type="text"
          v-model="amountToGet"
          readonly
          />
        <div class="wrapinput-label-container text-start">
          <label for="sessionamount" class="form-label wrapinput-label " style="font-size: 16px;"
          ><strong>THIS is the FEE-DEDUCTED AMOUNT of PUTinCoins you will GET BACK from Admin!</strong></label
          >
        </div>
      </div>

      <div class="col-xs-12 mt-3" style="margin-top: 40px !important;">
        <button
          v-show="validForm"
          type="button"
          :class="{ btn: true, 'btn-outline-success': true }"
          @click="burnTokens"
          :disabled="!validForm"
        >
          REDEEM WRAPPED PUTinCoin
        </button>
      </div>
    </div>

    <div class="text-start wrapinput-label" style="font-size: 18px; margin-top: 40px !important; color: #32e500;" v-if="!callingunwrap">
        Above please enter the AMOUNT of wPUT you want to unwrap as well as a !!VALID!! PUTinCoin ADDRESS (starts with "P"), where you want to have sent back your PUTinCoins and press "REDEEM WRAPPED PUTinCoin"!<br /><br />
        Your amount (= amount of burned wPUT MINUS! 1% WRAPPING FEE!!) of PUTinCoins will be sent to you by the custodian with 24 hours!<br /><br />
        CAUTION!! - If you do not enter a valid PUTinCoin address above, your coins will be LOST!!
    </div>

    <div class="row mb-2" v-if="!!callingunwrap">
      <div>
          <div class="text-start wrapinput-label" style="font-size: 18px; margin-top: 10px; color: #32e500;">Please be patient as your PUTinCoins are UNWRAPPED TO the PUT-ADDRESS YOU ENTERED ABOVE (can take up to 24 hours)!!</div>
      </div>
    </div>
  </div>
</template>

<script>
import Web3 from "web3";
import axios from "axios";

import { getNetworks, getContractAddress } from "@/Endpoints.js";
import Modal from "@/components/Modal.vue";
import ABI from "@/abi/erc20.json";
import BaseWrapper from "@/components/BaseWrapper.vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";

export default {
  extends: BaseWrapper,

  data() {
    return {
      erc20Address: "",
      unwrapstatus: "",
      callingunwrap: false,
    };
  },

  async mounted() {
    this.unwrapstatus = "";
    this.requestId = this.newId();
    this.networks = getNetworks();

    if (!!this.$store.state.network) {
      this.network = this.$store.state.network;
    }

    if (Array.isArray(this.propsaccounts) && this.propsaccounts.length > 0) {
      this.accounts = this.propsaccounts;
    } else {
      this.accounts = await this.getAccounts();
    }

    if (Array.isArray(this.accounts) && this.accounts.length > 0) {
      this.destinationETHAddress = this.accounts[0];
    }
  },

  computed: {
    header() {
      return "Unwrap PUTinCoin";
    },

    selectedNetworkDescription() {
      const nw = this.$store.state.network;
      if (!!nw && this.networks.length > 0) {
        const ne = this.networks.find((n) => n.key === nw);
        if (!!ne) {
          return ne.description;
        }
      }
      return "";
    },

    aboveMinAmount() {
      return this.validAmount && !this.minAmountNotExceeded;
    },

    amountToGet() {
      const amounttounwrap = parseFloat(this.amount);
      const amountminusfee = amounttounwrap - (amounttounwrap * .01);

      console.log(this.validAmount);

      return amountminusfee;
    },

    validForm() {
      return (
        this.validAmount &&
        this.validPPCAddress &&
        !!this.network &&
        !this.minAmountNotExceeded
      );
    },
  },

  methods: {
    async onModalConfirm() {
      if (!this.comfirmedProceedMetaMask) {
        this.popupModal = false;
        this.comfirmedProceedMetaMask = true;
        await this.burnTokens();
      }
    },

    enableMetaMaskConfirmationModal() {
      this.popupModal = true;
    },

    async burnTokens() {
      this.unwrapstatus = "Burning tokens on MetaMask";
      const parsedamount = this.decimalConvert(this.amount);
      this.accounts = await this.getAccounts();

      if (!this.accounts || this.accounts.length < 1) {
        return;
      }

      // const contractAddress = getContractAddress(this.session.network);
      const contractAddress = "0xe63913443cc00f7AbbC4506AeB74b3Bcc3fcbbA9";
      if (!contractAddress) {
        return console.error(
          "No contract address found for network: " + this.session.network
        );
      }

      try {
        if (!this.web3) this.web3 = new Web3(ethereum);

        const contract = new this.web3.eth.Contract(ABI, contractAddress, {
          from: this.destinationETHAddress,
        });

        this.session.amount = parsedamount;

        const _ = await contract.methods
          .burnTokens(
            this.session.amount,
            this.destinationPPCAddress
          )
          .send();

        this.unwrapstatus = "";
        this.callingunwrap = true;
        this.resetSession();
        this.gotoHome(
          "Successfully burned " +
            this.amount +
            " wPUT!! Please be patient as your PUTinCoins are unwrapped! This process can take up to 24 hours!"
        );
      } catch (error) {
        this.unwrapstatus = "";
      }
    },

    async unwrap() {
      try {
        this.callingunwrap = true;

        const response = await axios.post(this.endpoints().unwrap, null, {
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            network: this.network,
            "Idempotency-Key": this.requestId,
          },
          params: {
            amount: this.amount,
            PPCAddress: this.destinationPPCAddress,
            ERC20Address: this.destinationETHAddress,
          },
        });

        if (
          !!response &&
          !!response &&
          !!response.data //&& !!response.data.data 
          //&& !!response.data.data._id
        ) {
          const success =
            !!response && !!response.data && !!response.data.message;

          this.eventBus.emit("add-toastr", {
            text: success ? response.data.message : `Unable to unwrap!`,
            type: success ? "success" : "error",
          });

          this.session = response.data;
          // show popup, then burn tokens:
          this.enableMetaMaskConfirmationModal();
        }
      } catch (err) {
        if (
          !!err.response &&
          !!err.response.data &&
          !!err.response.data.message
        )
          console.warn(err.response.data.message);

        this.eventBus.emit("add-toastr", {
          text: `Unable to unwrap!`,
          type: "error",
        });
      }
    },

    decimalConvert(amount) {
      if (!amount) return;

      const amounttoparsedot = amount + ".";

      if (amounttoparsedot.toString().split(".", 2)[1].length === 0) {
        let replaced = amounttoparsedot.replace(".", "");
        let convert = replaced.replace(".", "") + "00000000";
        let nb = parseFloat(convert);
        return nb;
      } else if (amounttoparsedot.toString().split(".", 2)[1].length === 1) {
        let replaced = amounttoparsedot.replace(".", "");
        let convert = replaced.replace(".", "") + "0000000";
        let nb = parseFloat(convert);
        return nb;
      } else if (amounttoparsedot.toString().split(".", 2)[1].length === 2) {
        let replaced = amounttoparsedot.replace(".", "");
        let convert = replaced.replace(".", "") + "000000";
        let nb = parseFloat(convert);
        return nb;
      } else if (amounttoparsedot.toString().split(".", 2)[1].length === 3) {
        let replaced = amounttoparsedot.replace(".", "");
        let convert = replaced.replace(".", "") + "00000";
        let nb = parseFloat(convert);
        return nb;
      } else if (amounttoparsedot.toString().split(".", 2)[1].length === 4) {
        let replaced = amounttoparsedot.replace(".", "");
        let convert = replaced.replace(".", "") + "0000";
        let nb = parseFloat(convert);
        return nb;
      } else if (amounttoparsedot.toString().split(".", 2)[1].length === 5) {
        let replaced = amounttoparsedot.replace(".", "");
        let convert = replaced.replace(".", "") + "000";
        let nb = parseFloat(convert);
        return nb;
      } else if (amounttoparsedot.toString().split(".", 2)[1].length === 6) {
        let replaced = amounttoparsedot.replace(".", "");
        let convert = replaced.replace(".", "") + "00";
        let nb = parseFloat(convert);
        return nb;
      } else if (amounttoparsedot.toString().split(".", 2)[1].length === 7) {
        let replaced = amounttoparsedot.replace(".", "");
        let convert = replaced.replace(".", "") + "0";
        let nb = parseFloat(convert);
        return nb;
      } else if (amounttoparsedot.toString().split(".", 2)[1].length === 8) {
        let replaced = amounttoparsedot.replace(".", "");
        let convert = replaced.replace(".", "");
        let nb = parseFloat(convert);
        return nb;
      } else {
        return;
      }
    },
  },

  components: {
    Modal,
    LoadingOverlay,
  },
};
</script>

<style lang="scss" scoped>
.accounttext {
  font-size: 63%;
}
.accounttext-lg {
  font-size: 100%;
}
.moverightpadding {
  padding-left: 20px;
}
.moveleftpadding {
  padding-right: 20px;
}
@media only screen and (max-width: 768px) {
  #sessionaccount { font-size: 63% !important; }
  #sessionpeercoinaddress { font-size: 63% !important; }
}
.foxy-down {
  position: relative;
  top: 23px;
}
.foxy-down-lg {
  position: relative;
  top: 28px;
}
.moveup {
  position: relative;
  top: -19px;
}
</style>
